import accounts from "./endpoints/accounts";
import analytics from "./endpoints/analytics";
import auctioneer from "./endpoints/auctioneer";
import auth from "./endpoints/auth";
import bedrock from "./endpoints/bedrock";
import careseekers from "./endpoints/careseekers";
import * as chroma from "./endpoints/chroma";
import crypto from "./endpoints/crypto";
import requests from "./endpoints/requests";
import transport from "./transport";

export default {
  accounts,
  analytics,
  auctioneer,
  auth,
  bedrock,
  careseekers,
  chroma,
  crypto,
  requests,
  setAuthAccessor: transport.setAuthAccessor,
  setTokenAccessor: transport.setTokenAccessor,
  setTokenExpiration: transport.setTokenExpiration,
};
